<template>
  <div :class="{ 'center-editor-images': centerImages }">
    <!-- 富文本组件 -->
    <quill-editor v-model="content" :options="editorOption" ref="myQuillEditor"></quill-editor>
    <input type="file" @change="changeimage" :id="uploadImgId" style="display:none;" />
    <!-- 使用input 标签劫持原本视频上传事件，实现视频上传 -->
    <input type="file" accept="video/*" name="file" ref="uploadFileVideo" :id="uploadVideoId" @change="changevideo" style="display:none;">
  </div>
</template>

<script>
import { uploadMedia } from '@/api/adminV1'

import * as Quill from 'quill'
import ImageResize from 'quill-image-resize-module' // 引用，调整图片大小
Quill.register('modules/imageResize', ImageResize)

const fontSizeStyle = Quill.import('attributors/style/size')
fontSizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '36px', '48px']
Quill.register(fontSizeStyle, true)
const fonts = ['Microsoft-YaHei', 'KaiTi', 'SimSun', 'SimHei', 'FangSong', 'YouYuan', 'Arial', 'sans-serif']
const Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)

// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
  // ['blockquote', 'code-block'],     //引用，代码块
  [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
  [{ list: 'ordered' }, { list: 'bullet' }], // 列表
  [{ script: 'sub' }, { script: 'super' }], // 上下标
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  [{ direction: 'rtl' }], // 文本方向
  [{ size: fontSizeStyle.whitelist }], // 字体大小，false设置自定义大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
  [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
  [{ font: fonts }], // 字体
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除字体样式
  ['image', 'video'] // 上传图片、上传视频
]

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    uploadImgId: {
      type: String
    },
    uploadVideoId: {
      type: String
    },
    centerImages: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 富文本参数配置  自定义图片上传
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // container为工具栏，此次引入了全部工具栏，也可自行配置
            handlers: {
              image: (value) => {
                // QuillWatch.emit(this.quill.id)
                document.querySelector('#' + this.uploadImgId).click()
                // 劫持原来的图片点击按钮事件
              },
              video: (val) => { // 劫持原来的视频点击按钮事件
                document.querySelector('#' + this.uploadVideoId).click()
              }
            }
          },
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      },
      // 富文本的内容
      content: '',
      // 图片与视频的数组  用于与服务器做对比，删除多余的图片或视频
      imagesList: []
    }
  },
  methods: {
    changeimage (e) {
      this.uploadAndInsert(e.target.files[0], 'image')
    },
    changevideo (e) {
      this.uploadAndInsert(e.target.files[0], 'video')
    },
    uploadAndInsert (file, kind) {
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      uploadMedia(formData, kind).then(media => {
        this.imagesList.push(media)
        this.insertEle(kind, media.url)
      }).catch(() => {
        this.$message.error('Upload failed')
      })
    },
    insertEle (type, Url) {
      const quill = this.$refs.myQuillEditor.quill
      const length = quill.getSelection().index
      // 插入视频  response.data.url为服务器返回的图片地址
      // 跨域需要接上url
      var urlHeader = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL : ''
      var url = urlHeader + Url
      if (type === 'video') {
        quill.insertEmbed(length, type, url)
      } else {
        quill.insertEmbed(length, type, url)
      }
      // 调整光标到最后
      quill.setSelection(length + 1)
    }
  }
}
</script>

<style>
.center-editor-images .ql-editor img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
